import { getPatientCoverage } from "actions/patientAccessCuratorActions";
import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";

const loadPatientCoverage = async (
    dispatch: any,
    criteria: any,
    setIsPatientCoverageLoading: Function,
    isMounted: () => boolean // Add a parameter to check if the component is still mounted
) => {
    try {
        setIsPatientCoverageLoading(true);
        await dispatch(getPatientCoverage(criteria));
    } finally {
        if (isMounted()) { // Only call setIsPatientCoverageLoading if the component is still mounted
            setIsPatientCoverageLoading(false);
        }
    }
};

const useLoadPatientCoverage = (
    patient: any,
    dataValidityInDays: number,
    enableAutoFetch: boolean,
    shouldLoad: boolean,
    setIsPatientCoverageLoading: Function,
) => {
    const dispatch = useDispatch();
    const mountedRef = useRef(true); // Use a ref to track the mounted status so we don't do
    // something like setIsPatientCoverageLoading(false) on an unmounted component
    // aka it was loading in the background and no component cares if its done loading

    const criteria = {
        patient: patient,
        dataValidityInDays: dataValidityInDays,
        enableAutoFetch: enableAutoFetch, 
    }

    useEffect(() => {
        return () => {
            mountedRef.current = false;
        };
    }, []);

    useEffect(() => {
        // This function checks if the component is still mounted
        const isMounted = () => mountedRef.current;

        if (!shouldLoad) {
            return;
        }

        loadPatientCoverage(dispatch, criteria, setIsPatientCoverageLoading, isMounted);

    }, [patient, shouldLoad, dispatch, setIsPatientCoverageLoading]);
};

export default useLoadPatientCoverage;